import * as React from "react";
import { Avatar } from "../display/Avatar";

/**
 * Speaker-attributed transcript turn (meetings, live transcript). Speaker name takes the speaker color.
 */
export interface UtteranceProps {
  speaker: { name: string; speaker?: 1 | 2 | 3 | 4 | 5; initials?: string };
  time?: string;
  text: React.ReactNode;
  /** Butter ("now") background: this is the cited source */
  highlight?: boolean;
  /** Currently speaking: shows "speaking…" and a caret */
  live?: boolean;
  size?: "md" | "lg";
  avatarSize?: number;
  className?: string;
}

export function Utterance({ speaker, time, text, highlight, live, size = "md", avatarSize, className }: UtteranceProps): JSX.Element {
  const color = speaker.speaker ? "var(--speaker-" + speaker.speaker + ")" : "var(--text-strong)";
  const first = speaker.name.split(" ")[0];
  const cls = ["gk-utt", highlight && "gk-utt--highlight", live && "gk-utt--live", size === "lg" && "gk-utt--lg", className]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={cls}>
      <Avatar
        name={speaker.name}
        initials={speaker.initials}
        speaker={speaker.speaker}
        size={avatarSize || (size === "lg" ? 28 : 24)}
        ring={live ? "var(--action-ghost-bg-hover)" : undefined}
      />
      <div className="gk-utt__body">
        <div className="gk-utt__head">
          <span style={{ color }}>{first}</span>
          {live ? <span className="gk-utt__live">speaking…</span> : time && <span className="gk-utt__time">{time}</span>}
        </div>
        <div className="gk-utt__text">
          {text}
          {live && <span className="gk-caret" style={{ background: color }} />}
        </div>
      </div>
    </div>
  );
}
